module.exports = __webpack_public_path__ + "img/photo12.4bfcae72.jpg";